import { SET_THEME_COLOR } from "./actionTypes"

export const setThemeColor = (color) => {
  localStorage.setItem("themeColor", color)
  return {
    type: SET_THEME_COLOR,
    payload: color,
  }
}
